<template>
  <div class="dial-container">
    <!-- Barra de progresso -->
    <div
      v-if="isScrolling && !isPaused && !isOpen"
      class="progress-bar-container"
    >
      <v-progress-linear
        :value="scrollProgress"
        color="secondary"
        height="6"
        rounded
      />
      <div class="progress-text">
        <span class="font-weight-bold">{{ scrollProgress }}%</span>
        <span v-if="timeRemaining > 0">
          • {{ formatTime(timeRemaining) }} restantes</span
        >
      </div>
    </div>

    <div
      v-if="!isOpen"
      class="float-button"
      :style="{ width: isMenuOpen ? 'calc(100% - 180px)' : '100%' }"
      @click.stop="toggleDial"
    >
      <div>
        <v-icon class="float-icon" style="color: white"
          >keyboard_double_arrow_down</v-icon
        >

        <span>Rolagem automática</span>
      </div>
    </div>
    <div v-if="false" class="close-btn">
      <v-icon style="color: white">close</v-icon>
    </div>
    <div v-if="isOpen" class="dial-content">
      <v-btn fab small color="secondary" @click="handleToggleScrolling">
        <v-icon v-if="!isScrolling" :small="$vuetify.breakpoint.xs">
          play_arrow
        </v-icon>
        <v-icon v-else-if="isPaused" :small="$vuetify.breakpoint.xs">
          play_arrow
        </v-icon>
        <v-icon v-else :small="$vuetify.breakpoint.xs"> pause </v-icon>
      </v-btn>
      <v-btn color="secondary" fab small @click="openSettings">
        <v-icon :small="$vuetify.breakpoint.xs"> settings </v-icon>
      </v-btn>
      <v-btn color="secondary" fab small @click="closeDial">
        <v-icon :small="$vuetify.breakpoint.xs"> close </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloatMenu",
  props: {
    openSettingsDialog: {
      type: Function,
      required: true,
    },
    handleStart: {
      type: Function,
      required: true,
    },
    isScrolling: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    isMenuOpen: {
      get() {
        return this.$store.state.settings.drawer;
      },
    },
    isPaused() {
      return this.$store.state.autoScroll.isPaused;
    },
    scrollProgress() {
      if (typeof window === "undefined") return 0;
      const scrollElement =
        document.scrollingElement || document.documentElement;
      if (!scrollElement) return 0;
      const current = scrollElement.scrollTop;
      const total = scrollElement.scrollHeight - scrollElement.clientHeight;
      if (total <= 0) return 100;
      return Math.min(100, Math.round((current / total) * 100));
    },
    timeRemaining() {
      if (typeof window === "undefined") return 0;
      const scrollElement =
        document.scrollingElement || document.documentElement;
      if (!scrollElement) return 0;
      const remaining =
        scrollElement.scrollHeight -
        scrollElement.clientHeight -
        scrollElement.scrollTop;
      const speed = this.$store.getters["autoScroll/pixelsPerSecond"];
      return Math.max(0, Math.ceil(remaining / speed));
    },
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    formatTime(seconds) {
      if (seconds < 60) {
        return `${seconds}s`;
      }
      const minutes = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${minutes}m ${secs}s`;
    },
    toggleDial() {
      this.isOpen = !this.isOpen;
      if (!this.isScrolling) {
        this.handleStart();
      }
    },
    closeDial() {
      this.isOpen = false;
      this.$nextTick(() => {
        if (this.isScrolling && !this.isPaused) {
          // Para completamente ao fechar
          this.$emit("stop");
        }
      });
    },

    openSettings() {
      // Pausa se estiver rolando
      if (this.isScrolling && !this.isPaused) {
        this.$emit("pause");
      }
      this.openSettingsDialog();
    },
    handleToggleScrolling() {
      if (!this.isScrolling) {
        this.handleStart();
      } else if (this.isPaused) {
        this.$emit("resume");
      } else {
        this.$emit("pause");
      }
    },
  },
};
</script>

<style scoped>
.dial-container {
  position: relative;
}
.dial-content {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.float-button {
  position: fixed;
  bottom: -2px;
  right: 0;
  background-color: #1356a1;
  color: white;
  display: flex;
  justify-content: center;
  z-index: 100;
  padding: 8px;
  border-radius: 12px 12px 0 0;
  cursor: pointer;
  animation: moveUpDown 1.5s ease-in-out infinite;
}

.close-btn {
  position: fixed;
  bottom: 16px;
  right: 16px;
  padding: 2px;
  cursor: pointer;
  z-index: 1100;
  background-color: gray;
  border-radius: 50%;
}

@keyframes moveUpDown {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
}

.progress-bar-container {
  position: fixed;
  bottom: 50px;
  right: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.95);
  padding: 8px 16px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  z-index: 99;
  border-radius: 8px 8px 0 0;
}

.progress-text {
  text-align: center;
  font-size: 12px;
  color: #1356a1;
  margin-top: 4px;
}
</style>
